import { env } from ".env";

export const isProduction = process.env.NODE_ENV === "production";
export const isTrueEnvironment = env.envName !== "stage";
